/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, VFlow } from 'bold-ui'

import { ListaRegulacaoTableItem } from './model-regulacao'

export interface RegulacaoModalItemProps {
  item: ListaRegulacaoTableItem
}

export const renderItemRegulacao = (title: string, subtitle: string) => (
  <VFlow vSpacing={0}>
    <Heading level={5} fontWeight='bold'>
      {title}
    </Heading>
    <Heading level={5} fontWeight='normal' style={styles.subtitle}>
      {subtitle}
    </Heading>
  </VFlow>
)

const styles = {
  subtitle: css`
    word-break: break-word;
  `,
}
